import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { GridDataResult } from "@progress/kendo-angular-grid";
import { DataResult } from "@progress/kendo-data-query";
import { BehaviorSubject, Observable } from "rxjs-compat";
import { AppConstant } from "src/app/app.constant";
import { map } from "rxjs/operators";

@Injectable()
export class PlanService {
    apiUrl: string;
    kendoDataUrl: string;
    constructor(private httpClient: HttpClient,
        private appConstant: AppConstant) {
        this.apiUrl = this.appConstant.getUrl()
    }
    managePlan(Plan) {
        return this.httpClient.post(`${this.apiUrl}/managePlan`, Plan).pipe(
            map((response: any) => {
                return response;
            })
        )
    }
    getPlanById(planId) {
        return this.httpClient.get(`${this.apiUrl}/getPlanById/`+ planId).pipe(
            map((response: any) => {
                return response;
            })
        )
    }

    public getAllPlan(): Observable<DataResult> {
        return this.httpClient.get(`${this.apiUrl}/getAllPlan/`).pipe(
            map((response: any) => {
                return {
                    data: response.data,
                    total: response.total
                } as GridDataResult
            })
        ) as any as Observable<GridDataResult>
    }

    async getAllPlanAsync() : Promise<any[]> {
        return (await this.httpClient.get<GridDataResult>(`${this.apiUrl}/getAllPlan/`).toPromise()).data;
    }

    public getAllDefaultPlan(users : number): Observable<DataResult> {
        return this.httpClient.get(`${this.apiUrl}/getAllDefaultPlan?user=` + users).pipe(
            map((response: any) => {
                return {
                    data: response.data,
                    total: response.total
                } as GridDataResult
            })
        ) as any as Observable<GridDataResult>
    }
}